import React, { Component } from "react"
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from "prop-types"
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Box, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Collapse, Typography, Card, CardContent, Accordion,
  AccordionSummary, AccordionDetails, TextField, Chip
} from "@mui/material"
import { withStyles } from "@mui/styles"
import Pagination from '@mui/material/Pagination'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import moment from "moment"
import { injectIntl } from 'react-intl'
import { Styles } from "../../styles/material-styles"
import { Overlay } from "../../styles/global"
import CustomizedSnackbars from "../../components/material-snackbars"
import HeaderMenu from "../../components/header-menu"
import Footer from '../../components/footer'
import SimpleDatePicker from '../../components/date-pickers/inline-no-today'
import SimpleAutoComplete from '../../components/auto-complete/autocomplete'
import Api from "../../services/api"
import ApiReports from "../../services/apireport"
import * as calledsActions from '../../redux/actions/calleds'

const STATUS_KEYS = {
  1: 'noticeboard.status.scheduled',
  2: 'noticeboard.status.published',
  3: 'noticeboard.status.closed',
  4: 'noticeboard.status.archived'
}

class AnnouncementReport extends Component {
  constructor(props) {
    super(props)

    this.canAccess = false

    const { userSession } = this.props

    if (userSession == null || userSession.user == null || userSession.user.userrole == null)
      Api.logoff()

    userSession.user.userrole.map((item) => {
      if (item.role.roletype == 0 || item.role.roletype == 1 || item.role.roletype == 4)
        this.canAccess = true
    })

    this.state = {
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      titleFilter: '',
      organizationFilter: 0,
      statusFilter: 0,

      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      showGrid: false,

      announcementList: [],
      expandedRows: {},
      readersByAnnouncement: {},
      readersLoading: {},

      organizationList: [],
      statusList: Object.keys(STATUS_KEYS).map(id => ({
        id: Number(id),
        name: this.props.intl.formatMessage({ id: STATUS_KEYS[id] })
      })),

      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    }

    this.changeValues = this.changeValues.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.getOrganizations()
    this.setState({ loading: false })
  }

  getOrganizations = async () => {
    await Api.get('/organizations/list')
      .then(result => {
        if (result.data.success)
          this.setState({ organizationList: result.data.data })
      })
      .catch(() => {})
  }

  changeValues = async (stateName, value) => {
    if (value && value.id !== undefined) {
      this.setState({ [stateName]: value.id })
    } else {
      this.setState({ [stateName]: value })
    }
  }

  clearFilters = () => {
    this.setState({
      dateStart: moment().subtract(1, 'months').format('YYYY/MM/DD HH:mm:ss'),
      dateEnd: moment().format('YYYY/MM/DD HH:mm:ss'),
      titleFilter: '',
      organizationFilter: 0,
      statusFilter: 0,
      showGrid: false,
      announcementList: [],
      expandedRows: {},
      readersByAnnouncement: {},
      readersLoading: {},
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    await this.fetchReport()
  }

  buildFilterParams = (dateStart, dateEnd) => {
    let params = `startDate=${dateStart}&endDate=${dateEnd}`

    if (this.state.organizationFilter && this.state.organizationFilter !== 0)
      params += `&organizationId=${this.state.organizationFilter}`

    if (this.state.statusFilter && this.state.statusFilter !== 0)
      params += `&statusId=${this.state.statusFilter}`

    if (this.state.titleFilter && this.state.titleFilter.trim() !== '')
      params += `&title=${encodeURIComponent(this.state.titleFilter.trim())}`

    return params
  }

  fetchReport = async () => {
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

    if (moment(dateStart).isAfter(moment(dateEnd))) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: this.props.intl.formatMessage({ id: 'report.audit.initial.date.higher.than.end.date' }),
        loading: false
      })
      return
    }

    await this.fetchPaginate(dateStart, dateEnd, 1)

    this.setState({ showGrid: true, loading: false })
  }

  fetchPaginate = async (dateStart, dateEnd, page) => {
    const params = this.buildFilterParams(dateStart, dateEnd)

    await ApiReports.get(`/report/announcement/paginate?${params}&page=${page}&pageSize=10`)
      .then(result => {
        if (result.data.success) {
          this.setState({
            announcementList: result.data.data,
            count: result.data.count,
            page,
            expandedRows: {},
            readersByAnnouncement: {},
            readersLoading: {}
          })
          this.setPagination(result.data.count, page)
        } else {
          this.setState({
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: result.data.errors && result.data.errors[0]
              ? result.data.errors[0]
              : this.props.intl.formatMessage({ id: 'noticeboard.report.error.load' })
          })
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : this.props.intl.formatMessage({ id: 'noticeboard.report.error.load' })
        })
      })
  }

  onChangePaginate = (e, page) => {
    this.setState({ loading: true })
    const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
    const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')
    this.fetchPaginate(dateStart, dateEnd, page).then(() => {
      this.setState({ loading: false })
    })
  }

  setPagination = (count, page) => {
    const totalPage = Math.ceil(count / 10)
    this.setState({ totalPages: totalPage })
    if (count > 0) {
      if (page == 1) {
        this.setState({
          pageStart: 1,
          pageEnd: count < 10 ? count : 10
        })
      } else {
        const pageStart = ((page - 1) * 10) + 1
        this.setState({
          pageStart,
          pageEnd: count >= page * 10 ? page * 10 : count
        })
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0, pageStart: 0, pageEnd: 0 })
    }
  }

  toggleRow = async (id) => {
    const willExpand = !this.state.expandedRows[id]

    this.setState(prev => ({
      expandedRows: { ...prev.expandedRows, [id]: willExpand }
    }))

    if (willExpand && this.state.readersByAnnouncement[id] === undefined)
      await this.fetchReaders(id)
  }

  fetchReaders = async (id) => {
    this.setState(prev => ({ readersLoading: { ...prev.readersLoading, [id]: true } }))

    await ApiReports.get(`/report/announcement/readers/${id}`)
      .then(result => {
        if (result.data.success) {
          this.setState(prev => ({
            readersByAnnouncement: { ...prev.readersByAnnouncement, [id]: result.data.data || [] }
          }))
        } else {
          this.setState({
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: result.data.errors && result.data.errors[0]
              ? result.data.errors[0]
              : this.props.intl.formatMessage({ id: 'noticeboard.report.error.readers' })
          })
        }
      })
      .catch(err => {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: err.response && err.response.data && err.response.data.errors
            ? err.response.data.errors[0]
            : this.props.intl.formatMessage({ id: 'noticeboard.report.error.readers' })
        })
      })

    this.setState(prev => ({ readersLoading: { ...prev.readersLoading, [id]: false } }))
  }

  closeNotification = () => {
    this.setState({ openNotification: false })
  }

  exportExcel = async () => {
    this.setState({ loading: true })
    try {
      const dateStart = moment(this.state.dateStart).format('YYYY-MM-DD')
      const dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD')

      if (moment(dateStart).isAfter(moment(dateEnd))) {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: this.props.intl.formatMessage({ id: 'report.audit.initial.date.higher.than.end.date' }),
          loading: false
        })
        return
      }

      const payload = {
        DateStart: dateStart,
        DateEnd: dateEnd,
        Title: this.state.titleFilter && this.state.titleFilter.trim() !== '' ? this.state.titleFilter.trim() : null,
        StatusId: this.state.statusFilter && this.state.statusFilter !== 0 ? this.state.statusFilter : null,
        OrganizationId: this.state.organizationFilter && this.state.organizationFilter !== 0 ? this.state.organizationFilter : null
      }

      const response = await ApiReports.post('/report/announcement/excell/new', payload)
      if (response.data && response.data.success) {
        this.setState({
          openNotification: true,
          notificationVariant: "success",
          notificationMessage: this.props.intl.formatMessage({ id: "report.sent" }) + " (" + this.props.userSession.user.email + ")"
        })
      } else {
        this.setState({
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: response && response.data && response.data.errors && response.data.errors[0]
            ? response.data.errors[0]
            : this.props.intl.formatMessage({ id: "process.error" })
        })
      }
    } catch (error) {
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: error && error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]
          ? error.response.data.errors[0]
          : this.props.intl.formatMessage({ id: "process.error" })
      })
    }
    this.setState({ loading: false })
  }

  renderStatus(statusId) {
    const statusKey = STATUS_KEYS[statusId]
    const colors = {
      1: { backgroundColor: '#fef3c7', color: '#92400e' },
      2: { backgroundColor: '#dcfce7', color: '#166534' },
      3: { backgroundColor: '#e2e8f0', color: '#475569' },
      4: { backgroundColor: '#e2e8f0', color: '#475569' }
    }
    return <Chip size="small" label={statusKey ? this.props.intl.formatMessage({ id: statusKey }) : '-'} style={{ fontWeight: 600, ...(colors[statusId] || {}) }} />
  }

  renderReaders(item) {
    const readers = this.state.readersByAnnouncement[item.id]

    if (this.state.readersLoading[item.id])
      return <CircularProgress size={20} color="secondary" />

    if (!readers || readers.length === 0)
      return <Typography style={{ fontSize: 13, color: '#94a3b8' }}>{this.props.intl.formatMessage({ id: 'noticeboard.report.readers.empty' })}</Typography>

    return (
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 700 }}>{this.props.intl.formatMessage({ id: 'noticeboard.report.readers.user' })}</TableCell>
            <TableCell style={{ fontWeight: 700 }}>{this.props.intl.formatMessage({ id: 'noticeboard.report.readers.email' })}</TableCell>
            <TableCell style={{ fontWeight: 700 }}>{this.props.intl.formatMessage({ id: 'noticeboard.report.readers.readAt' })}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {readers.map(reader => (
            <TableRow key={reader.userid}>
              <TableCell>{reader.username || '-'}</TableCell>
              <TableCell>{reader.useremail || '-'}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>
                {reader.readat ? moment(reader.readat).format('DD/MM/YYYY HH:mm:ss') : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  renderMainTable() {
    const { announcementList } = this.state

    return (
      <Paper elevation={2} style={{ borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
        <Box style={{ padding: '16px 20px', backgroundColor: '#3F51B4', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="subtitle1" style={{ fontWeight: 600, color: 'inherit' }}>
            {this.props.intl.formatMessage({ id: 'noticeboard.report.grid.title' })}
          </Typography>
          <Typography variant="caption" style={{ opacity: 0.8, color: 'inherit' }}>
            {this.state.count} {this.props.intl.formatMessage({ id: 'noticeboard.report.records' })}
          </Typography>
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow style={{ backgroundColor: '#3F51B4' }}>
                <TableCell style={{ fontWeight: 700, width: 30, color: '#fff' }} />
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.report.column.id' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.manage.column.title' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.manage.column.author' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.manage.column.status' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.form.audience' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.manage.column.publishDate' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.form.closeDate' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }}>{this.props.intl.formatMessage({ id: 'noticeboard.manage.column.organizations' })}</TableCell>
                <TableCell style={{ fontWeight: 700, color: '#fff' }} align="right">{this.props.intl.formatMessage({ id: 'noticeboard.report.column.reads' })}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {announcementList.map((item, idx) => (
                <React.Fragment key={item.id}>
                  <TableRow hover style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                    <TableCell>
                      <IconButton size="small" onClick={() => this.toggleRow(item.id)}>
                        {this.state.expandedRows[item.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell style={{ fontWeight: 700 }}>#{item.id}</TableCell>
                    <TableCell style={{ maxWidth: 280 }}>
                      <Typography style={{ fontSize: 12, color: '#475569' }} noWrap>{item.title || '-'}</Typography>
                    </TableCell>
                    <TableCell>{item.authorname || '-'}</TableCell>
                    <TableCell>{this.renderStatus(item.statusid)}</TableCell>
                    <TableCell>{[1, 2, 3].includes(item.audienceid) ? this.props.intl.formatMessage({ id: `noticeboard.audience.${item.audienceid}` }) : '-'}</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {item.publishdate ? moment(item.publishdate).format('DD/MM/YYYY HH:mm') : '-'}
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {item.closedate ? moment(item.closedate).format('DD/MM/YYYY HH:mm') : '-'}
                    </TableCell>
                    <TableCell style={{ maxWidth: 220 }}>
                      <Typography style={{ fontSize: 12 }} noWrap title={item.organizationslabel}>{item.organizationslabel || '-'}</Typography>
                    </TableCell>
                    <TableCell align="right" style={{ fontWeight: 700 }}>{item.readcount}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: this.state.expandedRows[item.id] ? undefined : 'none' }} colSpan={10}>
                      <Collapse in={!!this.state.expandedRows[item.id]} timeout="auto" unmountOnExit>
                        <Box style={{ margin: '12px 0', padding: 16, backgroundColor: '#f8fafc', borderRadius: 8 }}>
                          <Typography variant="caption" color="textSecondary" style={{ fontWeight: 600 }}>
                            {this.props.intl.formatMessage({ id: 'noticeboard.report.readers.title' })}
                          </Typography>
                          {this.renderReaders(item)}
                        </Box>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
              {announcementList.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10} align="center" style={{ padding: 40, color: '#94a3b8' }}>
                    {this.props.intl.formatMessage({ id: 'noticeboard.report.empty' })}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    )
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props

    if (!this.canAccess) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    if (Api == null) {
      const l = this.props.match.params.lang
      document.location.href = `/${l}/unavailable`
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card>
                  <CardContent className="background-title-search">
                    <Typography variant="h5">
                      {this.props.intl.formatMessage({ id: 'noticeboard.report.title' })}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <form name='announcementReportForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography className={classes.heading}>{this.props.intl.formatMessage({ id: 'filters' })}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid container style={{ marginBottom: 20 }} spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label={this.props.intl.formatMessage({ id: 'start.date' })}
                        name='dateStart'
                        stateName='dateStart'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateStart}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleDatePicker
                        label={this.props.intl.formatMessage({ id: 'end.date' })}
                        name='dateEnd'
                        stateName='dateEnd'
                        changeDate={this.changeValues}
                        currentDate={this.state.dateEnd}
                        fullWidth={true}
                        required
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label={this.props.intl.formatMessage({ id: 'organization' })}
                        options={this.state.organizationList}
                        stateName='organizationFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.organizationList.find(item => item.id === this.state.organizationFilter) || { id: 0, name: '' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <SimpleAutoComplete
                        label={this.props.intl.formatMessage({ id: 'status' })}
                        options={this.state.statusList}
                        stateName='statusFilter'
                        changeSelect={this.changeValues}
                        selected={this.state.statusList.find(item => item.id === this.state.statusFilter) || { id: 0, name: '' }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        label={this.props.intl.formatMessage({ id: 'title' })}
                        value={this.state.titleFilter}
                        onChange={(e) => this.changeValues('titleFilter', e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                      />
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button type='submit' fullWidth variant='contained' color='secondary'>
                    {this.props.intl.formatMessage({ id: 'filter' })}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                  <Button fullWidth variant='contained' color='secondary' onClick={this.clearFilters}>
                    {this.props.intl.formatMessage({ id: 'noticeboard.report.clearFilters' })}
                  </Button>
                </Grid>
                {this.state.showGrid && (
                  <Grid item xs={12} sm={2} md={2} style={{ marginRight: 10, marginTop: 10 }}>
                    <Button fullWidth variant='contained' color='secondary' onClick={this.exportExcel}>
                      {this.props.intl.formatMessage({ id: 'noticeboard.report.export' })}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </form>

            {this.state.showGrid && (
              <>
                <Box style={{ marginTop: 32 }}>
                  {this.renderMainTable()}
                </Box>

                <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                  <Grid item xs={12} md={3}>
                    <Pagination count={this.state.totalPages} page={this.state.page} onChange={this.onChangePaginate} />
                  </Grid>
                  <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {this.props.intl.formatMessage({ id: 'noticeboard.report.range' }, { start: this.state.pageStart, end: this.state.pageEnd, total: this.state.count })}
                  </Grid>
                </Grid>
              </>
            )}

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification} />
          </Container>
        </main>
        <Footer />
      </div>
    )
  }
}

AnnouncementReport.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(calledsActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AnnouncementReport)))
